"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const ramda_adjunct_1 = require("ramda-adjunct");
const async_1 = __importDefault(require("react-select/async"));
function InputComponent(_a) {
    var { inputRef } = _a, props = __rest(_a, ["inputRef"]);
    return react_1.default.createElement("div", Object.assign({ style: {
            display: 'flex',
            padding: 0,
        }, ref: inputRef }, props));
}
function CreateControl(label, width, required, error) {
    return (props) => (react_1.default.createElement(core_1.TextField, { required: required, error: error, style: {
            display: 'flex',
            minWidth: width + "px",
        }, InputProps: {
            inputComponent: InputComponent,
            inputProps: Object.assign({ inputRef: props.innerRef, children: props.children, disabled: props.isDisabled }, props.innerProps),
        }, InputLabelProps: {
            shrink: props.isFocused || !ramda_adjunct_1.isNilOrEmpty(props.getValue()),
        }, label: label }));
}
function ValueContainer(props) {
    return react_1.default.createElement("div", { style: {
            display: 'flex',
            flexWrap: 'wrap',
            flex: 1,
            alignItems: 'center',
        } }, props.children);
}
const customStyles = {
    dropdownIndicator: (oriStyles) => (Object.assign(Object.assign({}, oriStyles), { paddingTop: 6, paddingBottom: 6 })),
    clearIndicator: (oriStyles) => (Object.assign(Object.assign({}, oriStyles), { paddingTop: 6, paddingBottom: 6 })),
};
function Select(props) {
    const [defaultOptions, setDefaultOptions] = react_1.useState(props.value != null ? [props.value] : []);
    const loadOptions = (inputValue, callback) => __awaiter(this, void 0, void 0, function* () {
        let options = yield props.options(inputValue);
        callback(options);
    });
    react_1.useEffect(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            yield loadOptions(props.value === undefined ? '' : props.value.label, (options) => {
                setDefaultOptions(options);
            });
        }))();
    }, []);
    // noinspection JSUnusedGlobalSymbols
    return (react_1.default.createElement(async_1.default, { isDisabled: props.disabled, styles: customStyles, loadOptions: loadOptions, cacheOptions: true, style: {
            display: 'flex',
            flexGrow: 1,
        }, value: props.value, components: {
            Control: CreateControl(props.label, props.width == null ? 200 : props.width, props.required, props.error),
            ValueContainer,
        }, onChange: (value) => {
            if (props.onChange != null) {
                props.onChange(value);
            }
        }, tabSelectsValue: true, placeholder: "", defaultOptions: defaultOptions }));
}
exports.default = Select;
